<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            @import-items="importItems"
                            ref="gofixTable">
                            <template slot="gofix_table:qr_code" slot-scope="row">
                                <b-button
                                    @click="showQRCode(row.item)" 
                                    class="goFixPrintButton" 
                                    title="Print">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-qr-code" viewBox="0 0 16 16">
                                            <path d="M2 2h2v2H2z"/>
                                            <path d="M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z"/>
                                            <path d="M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z"/>
                                            <path d="M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z"/>
                                            <path d="M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z"/>
                                        </svg>
                                </b-button>
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            :title="`${modals.add.data.id ? 'Edit' : 'Add'} QR Code`" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-input 
                            label="Serial Code" 
                            required
                            show-icon-required
                            v-model="modals.add.data.serial_code">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="TC Code" 
                            disabled
                            v-model="modals.add.data.tc_code">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="Name" 
                            disabled
                            v-model="modals.add.data.name">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="In Property" 
                            disabled
                            v-model="modals.add.data.in_property">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="Location" 
                            disabled
                            v-model="modals.add.data.location">
                        </gofix-form-input>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>

        <b-modal :no-close-on-backdrop="true"
            id="modal-Create"
            title="QR Code" hide-footer :centered="true"
            v-model="modals.qr_code.open">
            <div class="preview">
                <gofix-text-field class="mb-3" label="URL" inputStyle>
                    {{modals.qr_code.data.serial_code}}
                </gofix-text-field>
                <gofix-text-field label="QR Code" inputStyle>
                    <div class="text-center">
                        <qrcode-vue :value="`${modals.qr_code.data.serial_code}`" :size="130" level="L"></qrcode-vue>
                        <gofix-button label="Download Hi-res QR Image" @click="downloadQRCode" outline></gofix-button>
                    </div>
                </gofix-text-field>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import QrcodeVue from 'qrcode.vue'
export default {
    name: 'job-list-qr-codes',
    components: {
        QrcodeVue
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['job_list_qr_codes']));
        return {
            tableConfig:{
                name: 'job-list-qr-codes',
                controls:{
                    create: false,
                    delete: false,
                    tableColumnSettings: false,
                    tableImport: false,
                    tableExport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "desc",
                fields: [
                        {
                            key: 'tc_code',
                            label: 'TC Code',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            thStyle: "width:300px",
                            width: null,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'serial_code',
                            label: 'Serial Code',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'in_property',
                            label: 'In Property',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'location',
                            label: 'Location',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'qr_code',
                            label: 'QR Code',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                    ]
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        name: null,
                        tc_code: null,
                        name: null,
                        serial_code: null,
                        in_property: null,
                        location: null,
                    },
                    options: {
                        companies: []
                    },
                },
                qr_code: {
                    open: false,
                    data: {
                        id: null,
                        serial_code: null
                    }
                }
            },
            timer: {
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("RunsheetController/getJobQRCodes", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of workers", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
            if(!this.$checkRole(this.$accessModule.job_list, 'update')) return
            this.modals.add.data = {
                id: item.id,
                name: item.name,
                tc_code: item.tc_code,
                serial_code: item.serial_code,
                in_property: item.in_property,
                location: item.location,
            };

            this.modals.add.open = true;
        },
        newItem() {
            if(!this.$checkRole(this.$accessModule.job_list, 'create')) return
            this.modals.add.data = {
                id: null,
                name: null,
                tc_code: null,
                serial_code: null,
                in_property: null,
                location: null,
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            //
        },
        exportItems(tableRequest) {
            //
        },
        async importItems(callback){
            //
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                
                if(!this.modals.add.data.serial_code) {
                    return this.$alertNotification("Serial Code is required.", "danger");
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    id: this.modals.add.data.id,
                    data: {
                        name: this.modals.add.data.name,
                        tc_code: this.modals.add.data.tc_code,
                        serial_code: this.modals.add.data.serial_code,
                        in_property: this.modals.add.data.in_property,
                        location: this.modals.add.data.location,
                    }
                };
                
                this.$store.dispatch("RunsheetController/updateJobQRCodes", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    this.modals.add.open = false;
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(this.$notificationV2('adding', 'job_list_qr_codes'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        showQRCode(item) {
            this.modals.qr_code.data.id = item.id;
            this.modals.qr_code.data.serial_code = item.serial_code;
            this.modals.qr_code.open = true;
        },
        downloadQRCode() {
            this.$store.dispatch(`RunsheetController/downloadJobQRCode`, this.modals.qr_code.data.id)
                .then(response => {
                    const link = document.createElement('a');
                    link.href = response;
                    link.setAttribute('download', `${this.modals.qr_code.data.serial_code}.png`);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    console.log(error);
                })
        },
    },
    created() {
        //
    }
}
</script>